import { mode } from "@chakra-ui/theme-tools";
export const globalStyles = {
  colors: {
    brand: {
      100: "#f7e2b8",
      200: "#f3cf8b",
      300: "#efbc5e",
      400: "#edae40",
      500: "#eca028",
      600: "#e89524",
      700: "#e1871e",
      800: "#db7818",
      900: "#d3610e",
    },
    brandScheme: {
      100: "#f7e2b8",
      200: "#f3cf8b",
      300: "#efbc5e",
      400: "#edae40",
      500: "#eca028",
      600: "#e89524",
      700: "#e1871e",
      800: "#db7818",
      900: "#d3610e",
    },
    brandTabs: {
      100: "#f7e2b8",
      200: "#f3cf8b",
      300: "#efbc5e",
      400: "#edae40",
      500: "#eca028",
      600: "#e89524",
      700: "#e1871e",
      800: "#db7818",
      900: "#d3610e",
    },
    secondaryGray: {
      100: "#ffffff",
      200: "#f8f8f8",
      300: "#efefef",
      400: "#e4e4e4",
      500: "#d3d3d3",
      600: "#aeaeae",
      700: "#8e8e8e",
      800: "#666666",
      900: "#535353",
    },
    red: {
      100: "#FEEFEE",
      500: "#EE5D50",
      600: "#E31A1A",
    },
    blue: {
      50: "#EFF4FB",
      500: "#3965FF",
    },
    orange: {
      100: "#f7e2b8",
      500: "#eca028",
    },
    green: {
      100: "#E6FAF5",
      500: "#01B574",
    },
    navy: {
      50: "#f8f8f8",
      100: "#efefef",
      200: "#e4e4e4",
      300: "#d3d3d3",
      400: "#aeaeae",
      500: "#8e8e8e",
      600: "#666666",
      700: "#535353",
      800: "#353535",
      900: "#151515",
    },
    gray: {
      100: "#f8f8f8",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        bg: mode("secondaryGray.300", "navy.900")(props),
        letterSpacing: "-0.5px",
      },
      input: {
        color: "gray.700",
      },
      html: {
      },
    }),
  },
};
